import { render, staticRenderFns } from "./PageProfileCard.vue?vue&type=template&id=789d7d2c&scoped=true&"
import script from "./PageProfileCard.vue?vue&type=script&lang=ts&"
export * from "./PageProfileCard.vue?vue&type=script&lang=ts&"
import style0 from "./PageProfileCard.vue?vue&type=style&index=0&id=789d7d2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789d7d2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
